import { useEffect } from "react";

const useInterceptXMLHttpRequest = (token: string) => {
  useEffect(() => {
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.send = function (body) {
      try {
        const parsedBody = typeof body === 'string' ? JSON.parse(body || '{}') : {};
        if (
          parsedBody?.events &&
          'visit_token' in parsedBody &&
          'visitor_token' in parsedBody &&
          !parsedBody.visit_token &&
          !parsedBody.visitor_token
        ) {
          parsedBody.visit_token = token;
          parsedBody.visitor_token = token;
          body = JSON.stringify(parsedBody);
        }
      } catch (error) {
        console.error('Error parsing body:', error);
      }

      return originalSend.apply(this, [body]);
    };

    return () => {
      XMLHttpRequest.prototype.send = originalSend;
    };
  }, [token]);
};

export default useInterceptXMLHttpRequest;